import * as types from './logSourcesActionTypes';

export default (state = true, action) => {
    switch(action.type) {
        case types.LOAD_LOG_SOURCES:
            return true;
        case types.LOAD_LOG_SOURCES_FAILED:
        case types.LOAD_LOG_SOURCES_SUCCESS:
            return false;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/log-sources/logSourcesIsLoadingReducer.js